import { useEffect } from 'react';

import { useMainActions } from '../store';

export const useFetchSharedDocument = (shareDocumentId) => {
  const mainActions = useMainActions();

  /**
   * Query initial data
   */
  useEffect(() => {
    if (!shareDocumentId) {
      return undefined;
    }

    // Refresh current customer data in global and local stores
    mainActions.loadSharedProject(shareDocumentId);
  }, [shareDocumentId, mainActions]);
};
